import { createSelector } from 'reselect';

const getPttHelper = (state) => {
    return state?.userinfo?.permissionToTrack;
};

const getTokenHelper = (state) => {
    return state?.userinfo?.accessToken;
};

export const getPermissionToTrack = createSelector(
    [ getPttHelper],
    ( permissionToTrack ) => ( permissionToTrack )
);

export const getAccessToken = createSelector(
    [ getTokenHelper ],
    ( accessToken ) => ( accessToken )
);